export const SIDEBAR_OPEN = 'SIDEBAR_OPEN'
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE'
export const GET_PRODUTOS_BEGIN = 'GET_PRODUTOS_BEGIN'
export const GET_PRODUTOS_SUCCESS = 'GET_PRODUTOS_SUCCESS'
export const GET_PRODUTOS_ERROR = 'GET_PRODUTOS_ERROR'
export const GET_SINGLE_PRODUTOS_BEGIN = 'GET_SINGLE_PRODUTOS_BEGIN'
export const GET_SINGLE_PRODUTOS_SUCCESS = 'GET_SINGLE_PRODUTOS_SUCCESS'
export const GET_SINGLE_PRODUTOS_ERROR = 'GET_SINGLE_PRODUTOS_ERROR'
export const LOAD_PRODUTOS = 'LOAD_PRODUTOS'
export const SET_GRIDVIEW = 'SET_GRIDVIEW'
export const SET_LISTVIEW = 'SET_LISTVIEW'
export const UPDATE_SORT = 'UPDATE_SORT'
export const SORT_PRODUTOS = 'SORT_PRODUTOS'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const FILTER_PRODUTOS = 'FILTER_PRODUTOS'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'
export const TOGGLE_CART_ITEM_AMOUNT = 'TOGGLE_CART_ITEM_AMOUNT'
export const CLEAR_CART = 'CLEAR_CART'
export const COUNT_CART_TOTALS = 'COUNT_CART_TOTALS'
